export default {
  general: 'General',
  request_price: 'Request Price',
  place_order: 'Place Order',
  request_license: 'Request License',
  support: 'Support',
  ip: 'IP',
  invoicing: 'Invoicing',
  usage_stats: 'Usage Stats'
}
